import styled, { css } from 'styled-components';

export const Container = styled.form`
  ${({}) => css`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin: 1rem 0;
  `}
`;

export const Control = styled.button<{ active?: boolean }>`
  ${({ active = false }) => css`
    font-size: 17px;
    border: none;
    border-radius: 4px;
    min-height: 38px;
    ${active
      ? css`
          background: linear-gradient(to right, #11465d, #3e6380);
          color: white;
          &:hover {
            background: linear-gradient(to right, #11465d, #3e6380);
            background-color: #cfcfcf;
            background-blend-mode: multiply;
          }
          &:active {
            background: linear-gradient(to right, #11465d, #3e6380);
            background-color: #c2c1c1;
            background-blend-mode: multiply;
          }
        `
      : css`
          background: #d9d9d9;
          color: black;
          &:hover {
            background: #cfcfcf;
          }
          &:active {
            background: #c2c1c1;
          }
        `}
  `}
`;
